module.exports = __webpack_public_path__ + "img/default_listing_image.9b0b236f59f65c2fb6b2ba80b0237b52.svg";